import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import PreLoader from './Sections/PreLoader';
import Widgets from './Sections/Widgets';
import Download from './Sections/Download';
import Home from './Sections/Home';
import Tutorials from './Sections/Tutorials';
import Contactus from './Sections/Contactus';
import Buy from './Sections/Buy';
const RouteHandler = () => {
    const navigate = useNavigate();
    const handleComponent = () => {
        // Trigger navigation or other actions
    };

    // Similar handleClick function adjusted for use inside RouteHandler
    const handleClick = (data) => {
        console.log(data);
        switch (data) {
            case 'Downloads':
                navigate('/downloads');
                break;
            case 'Home':
                navigate('/home');
                break;
            case 'Tutorials':
                navigate('/tutorials');
                break;
            case 'Contacts us':
                navigate('/contactus');
                break;
            case 'Buy':
                navigate('/buy');
                break;
            default:
                navigate('/');
        }
    };

    return <Widgets handleClick={handleClick} />;
};

const MobileComponents = () => {
    const [preloader, setPreloader] = useState(true);

    useEffect(() => {
        // Simulating loading process
        setTimeout(() => setPreloader(false), 1000);
    }, []);

    return (
        <Router>
            {preloader ? (
                <PreLoader />
            ) : (
                <Routes>
                    <Route path="/downloads" element={<Download />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/tutorials" element={<Tutorials />} />
                    <Route path="/contactus" element={<Contactus />} />
                    <Route path="/buy" element={<Buy />} />
                    <Route path="/" element={<RouteHandler />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            )}
        </Router>
    );
}

export default MobileComponents;
